import { Vue, Component } from 'vue-property-decorator';
import { CreateElement } from 'vue';
import { VIcon } from 'vuetify/lib';

@Component({
  name: 'UserIcon',
})
export default class UserIcon extends Vue {

  private render(createElement: CreateElement) {
    return createElement(VIcon, {
      class: 'button',
    }, '$vuetify.icons.user_icon');
  }
}
